import { __awaiter } from "tslib";
import { Container, Service } from './container';
import Time from 'date-and-time';
import { Api } from './api';
import { Auth } from './auth';
import { SessionManager } from './session-manager';
const SCOPES_STORE = 'scopes';
export class WidgetConnect extends Service {
    constructor() {
        super(...arguments);
        this.api = this.ctx.get(Api).create(process.env.API_BASE_URL);
        this.auth = this.ctx.get(Auth);
        this.session = this.ctx.get(SessionManager);
    }
    resendEmail(provider, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/widget-connect/${provider}/resend-email`, {
                body: data
            });
            return body;
        });
    }
    getSignUpToken(token, account) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.auth.getSignUpToken(token, account);
        });
    }
    getSignUpEmail(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/widget-connect/${this.auth.provider}/account/by-email`;
            const { body } = yield this.api.get(`${url}?email=${encodeURIComponent(data.loginEmail)}&account=${data.account}&firstName=${data.firstName}&lastName=${encodeURIComponent(data.lastName)}`);
            return body;
        });
    }
    postSignUpEmail(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/widget-connect/${this.auth.provider}/connect/by-email`, {
                body: data
            });
            return body;
        });
    }
    createCustomer(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { body } = yield this.api.post(`/widget-connect/customer`, {
                body: data
            });
            return body;
        });
    }
    codeValidation(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.auth.codeValidation(data);
        });
    }
    postSignUpToken(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.auth.postSignUpToken(data);
        });
    }
    getScopes(account) {
        return __awaiter(this, void 0, void 0, function* () {
            let scopes = this.session.get(SCOPES_STORE);
            if (!scopes) {
                try {
                    const { body } = yield this.api.get(`/widget-connect/${this.auth.provider}/scopes?account=${account}`);
                    scopes = body;
                }
                catch (error) {
                    scopes = [];
                }
            }
            this.session.set(SCOPES_STORE, scopes, {
                expires: Time.addDays(new Date(), 1),
                validBusiness: true
            });
            return scopes;
        });
    }
    loadAuthState() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.auth.loadState();
        });
    }
}
Container.add(WidgetConnect);
